import type { ComponentProps } from 'react'

import Lottie from 'lottie-react'

import lottie from './lottie2.json'

type HandClickingAnimationProps = Omit<
  ComponentProps<typeof Lottie>,
  'animationData'
>

export function HandClickingAnimation(props: HandClickingAnimationProps) {
  return <Lottie animationData={lottie} {...props} />
}
